import ValidateError from './ValidateError';

export class NotEqualityValidationError extends ValidateError {
  constructor(key, checkKey) {
    super('error.not equality', key);
    this._data.checkKey = checkKey;
  }
}

const presenceContent = function(value, options, key, attributes) {
  let targetKey = options.key || options;
  let targetVal = attributes[targetKey];

  if (targetVal !== null && targetVal === value) {
    return new NotEqualityValidationError(key, targetKey);
  }
};

export default presenceContent;



// WEBPACK FOOTER //
// ./src/utilites/validate/notEquality.js